import { StoryblokLink } from '../types/StoryblokLink';
import { locales, defaultLocale } from '../translations/i18nConfig';

export const formatStoryblokLink = (link?: StoryblokLink, locale = defaultLocale): string => {
  if (!link) return '#';

  const baseUrl = `/${(link.cached_url || '').replace(/^(\/|\/$)/g, '')}`;

  switch (link.linktype) {
    case 'story':
      if (locales.some((loc) => baseUrl.startsWith(`/${loc}`))) {
        return baseUrl;
      }
      return locale === defaultLocale ? baseUrl : `/${locale}${baseUrl}`;
    case 'url':
      return link.url || '#';
    default:
      return link.url || '#';
  }
};
